import "@ant-design/v5-patch-for-react-19";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConfigProvider } from "antd";
import App from "./App.jsx";
// Same self-hosted Inter weights as the EasyLife staff app's OTP logins, so
// this portal reads as the same product rather than a font swap giving it away.
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "./index.css";

/**
 * Mirrors EasyLife's own src/theme.js shape — light-mode only (no dark-mode
 * toggle in this external portal) — but with the board-director portal's
 * lighter green (#45AE55) as colorPrimary instead of the staff app's darker
 * #189F6B, per direction.
 */
const theme = {
  token: {
    colorPrimary: "#45AE55",
    colorLink: "#45AE55",
    borderRadius: 8,
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    colorBgContainer: "#ffffff",
    colorBgLayout: "#f4f6f8",
    colorTextBase: "#1f2933",
  },
  components: {
    Button: { controlHeight: 40, fontWeight: 500 },
    Table: {
      headerBg: "#fafafa",
      headerColor: "#4b5563",
      rowHoverBg: "#f0fdf4",
      borderColor: "#f0f0f0",
    },
    Input: { activeBorderColor: "#45AE55", hoverBorderColor: "#45AE55" },
    Select: { optionSelectedBg: "#f0fdf4" },
    Steps: { colorPrimary: "#45AE55" },
    Form: { labelColor: "#374151" },
  },
};

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ConfigProvider theme={theme}>
      <App />
    </ConfigProvider>
  </StrictMode>,
);
